import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const inviteClientURL = process.env.REACT_APP_INVITE_CLIENT_URL;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
